// extracted by mini-css-extract-plugin
export default {"container":"ProfileImage_container__ERoHm","img":"ProfileImage_img__ZLwD8","text":"ProfileImage_text__zSc+c"};